import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileExplorerService } from 'app/services/file-explorer.service';
import PSPDFKit from 'pspdfkit';

@Component({
  selector: 'app-pdf-edit',
  templateUrl: './pdf-edit.component.html',
  styleUrls: ['./pdf-edit.component.scss']
})
export class PdfEditComponent implements OnInit, AfterViewInit {

  storageId: number = 0;
  filePath: string = '';
  isLoading: boolean = true;

  constructor(public fileService: FileExplorerService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.isLoading = true;
    this.activatedRoute.params.subscribe(params => {
      this.storageId = +params['storageId'];
      this.filePath = decodeURIComponent(params['path']);

      setTimeout(() => {
        this.isLoading = false;
      }, 1);

      PSPDFKit.load({ 
        baseUrl: location.protocol + "//" + location.host + "/assets/",
        document: this.fileService.directFileURL(this.filePath, this.storageId),
        container: '.pdf_app',
        autoSaveMode: PSPDFKit.AutoSaveMode.INTELLIGENT,
        licenseKey: 'GmcYyKM0S1DBQoUIwkua1HPUa7wIO9svK-svYSoOyOpnqqUL0Iy72cimCUCpnFH7l-fDiOIo-dgVMTZMVy0yPLMdLVcDt_lNkz3ZM9pnUbBzPebCZ5U-TAN2SU8gQzwGZTAXgd8j0z_2co71SzYt-TEUnu1aXE8ps8xT7r3URyrN_tkTzY_GLaTXpr-0OcXRvMEPob5dj6WLPuz6EGztdpS_6QhiBpUpiQQy7mIBqWGSq_KMaX6YCRn1XJ6jJLHqzguIW8Uw8yyubkO73sbQKnNMuLLNdynO1PzeMwar81IZMc_AIHnyopq_nlc8gYgYBmK2kG7pDSZRSHCcvGYv38GWOeGQC6qalmX-yl3olqQNeYQVC5Pl8YLT51Ole6qOGdmoZOrOtaVGHBXTZEAhtQtNRbAE7b3o9-F-HmC_XxSGSQegr85ayzUPOeVZH-InK_1GVg8BUrUGwIt--mAkUeEo3nm6u7aQHXBergGiwiOfWiPfE8_llib9HYi0GVhJ2PV6U9BtannzDFRPCyTj97BQoeXQ3jV_NQi53YyrkUUXKyZoxwTJNOuHez6oQNfYgW8BjU5vK4sl8BImv7dNbNGP73vVNxw16JkxbUX2Fzds9Vmm-jMEpPXon3ECXYSB8TmYMuACosBF8VHZTUsHFu-9TNlLSS9nGBmQh8z2FYAbYxxmjHTSigKEExr02HVA',
      }).then(function (instance) {
        // For the sake of this demo, store the PSPDFKit for Web instance
        // on the global object so that you can open the dev tools and
        // play with the PSPDFKit API.
        (window as any).instance = instance;

        instance.addEventListener("document.saveStateChange", event => {
          console.log(`Save state changed: ${event.hasUnsavedChanges}`);
          if (!event.hasUnsavedChanges) {
            /** @todo sync back to the server */
          }
        });
      });
    });
  }
}
